







































































































import { defineComponent } from "@vue/composition-api";
import { useUserStore } from '@/pinia/modules/user'
import { storeToRefs } from 'pinia'
import Avatar from '@/components/Avatar.vue'
export default defineComponent({
  components: {
    Avatar
  },
  setup(props, { root }) {
    const userStore = useUserStore()
    const { userInfo } = storeToRefs(userStore)
    return {
      userStore,
      userInfo,
    }
  }
});
